import { cn } from 'cn'
import { RadioGroupItem } from '@/ui/radio-group'

interface RadioOptionRowProps {
  readonly id: string
  readonly value: string
  readonly label: string
  readonly selected: boolean
  readonly dataTour?: string
}

/** A bordered radio row used inside a RadioGroup. Highlights when selected. */
function RadioOptionRow({ id, value, label, selected, dataTour }: RadioOptionRowProps) {
  return (
    <label
      htmlFor={id}
      className={cn(
        'flex cursor-pointer items-center gap-3 rounded-xl border px-4 py-3',
        selected ? 'border-primary bg-accent' : 'border-border',
      )}
      data-tour={dataTour}
    >
      <RadioGroupItem value={value} id={id} />
      <p className="flex-1 text-sm font-semibold text-foreground">{label}</p>
    </label>
  )
}

export { RadioOptionRow }
